import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { fetchData } from '../api';
import MovieLoading from './utils/Loading.js';
import { capitalize } from './utils/utils.js';

import Sidebar from './Sidebar';

import './MoviePage.css';

function extractDomain(url) {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const parts = hostname.split('.');

    // Handle cases like "www.example.com" or "example.co.uk"
    let domain = parts.slice(-2).join('.');

    // Extract just the "example" part
    domain = domain.split('.')[0];

    return domain;
  } catch (error) {
    // Handle invalid URLs
    console.error("Invalid URL:", error);
    return null; // Or some other appropriate error value
  }
}

function crop(text) {
  const size = 1300;
  if (text.length < size) {
    return text;
  }
  const sub = text.substring(0, size);

  for (let i = size - 1; i >= 0; i--) {
    if (sub[i] === ".") {
        return sub.substring(0, i) + "...";
    }
  }
  return sub;
}


const MoviePage = ({ match }) => {
  const [movie, setMovie] = useState(null);
  const [trailer, setTrailer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [trailerError, setTrailerError] = useState(null);
  const params = useParams();
  const movieId = params.id;

  useEffect(() => {
    const fetchMovie = async () => {
      setLoading(true);
      try {
        const { data } = await fetchData(`/api/movie/${movieId}/`);
        // not a promise object
        setMovie(data);
        return data;
      } catch (err) {
        setError(err.message);
        return null;
      } finally {
        setLoading(false);
      }
    };


    const loadTrailer = async () => {
      const movieData = await fetchMovie();
      let code = null;
      if (movieData !== null) {
        for (const link of movieData.links) {
          if (link.label === "Trailer") {
              for (const chunk of link.url.split("/")) {
                  code = chunk;
              };
          }
        }
      }

      if (code) {
          setTrailer({"code": code, "id": movieData.id});
      }
      else {
         setTrailerError("No trailer available!");
      }
    };
    loadTrailer();
  }, [movieId]);


  if (loading) {
    return <MovieLoading/>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  let tag_metadata = new Map();
  for (const tag of movie.tags) {
    if (tag_metadata.has(tag["category"])) {
      tag_metadata.get(tag["category"]).push(tag.name);
    }
    else {
      tag_metadata.set(tag.category, [tag.name]);
    }
  }
  let cover = null;
  for (const link of movie.links) {
    if (link.label === "Cover") {    
        cover = <img key={link.url} alt="cover" src={link.url}/>;
    }
  }

  const providers = [];
  const providerLinks = movie.links.filter(link => link.label === "Provider");

  providerLinks.forEach((link, index) => {
    providers.push(
      <a href={link.url} key={link.url} className="provider-link-page">
        {capitalize(extractDomain(link.url))}
      </a>
    );
  });

  return (
  <div className="recommendations-layout">
   <Sidebar allMovies={[movie]} />
  <div className="movie-detail-container">
    {/* Movie Header */}
    <div className="movie-header">
      <h1 className="movie-title">{movie.title}</h1>
      <div className="movie-meta">
        <span className="movie-year">{movie.release_year}</span>
        <span className="meta-separator">•</span>
        <span className="movie-runtime">{movie.runtime} minutes</span>
        <span className="meta-separator">•</span>
        <div className="rating-pill">
          {movie.rating / 100}
        </div>
      </div>
    </div>

    {/* Cover Image */}
    <div className="movie-cover-container">
      {cover}
    </div>

    {/* Movie Content */}
    {movie ? (
      <div className="movie-content">
        {/* Trailer Section */}
        <section className="trailer-section">
          <h2 className="section-title">Trailer</h2>
          <div className="movie-media-trailer">
              <div className="trailer-container">
                <iframe 
                  src={`https://www.youtube.com/embed/${trailer.code}`} 
                  title={`${movie.title} Official Trailer`}
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen
                  className="trailer-iframe"
                ></iframe>
              </div>
          </div>
        </section>

        {/* Synopsis Section */}
        {movie.description && (
          <section className="synopsis-section">
            <h2 className="section-title">Synopsis</h2>
            <div className="synopsis-content">
              <p className="movie-description-page">{crop(movie.description)}</p>
            </div>
          </section>
        )}

        {/* Providers Section */}
        {providers && (
          <section className="providers-section">
            <h2 className="section-title" style={{fontSize: "1.5rem"}}>Available On</h2>
            <div className="providers-container">
              {providers}
            </div>
          </section>
        )}

      </div>
    ) : (
      <div className="error no-movie-found">
        No movie found. Please try another selection.
      </div>
    )}
  </div>
  </div>
);
};

export default MoviePage;

